import React from 'react';
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  SortableContext,
  useSortable,
  arrayMove,
  rectSortingStrategy
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import CanvasRenderer from '../CanvasRenderer';

function SortableItem({ child, selectedChildId, onSelect }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: child.id });

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      onClick={(e) => {
        e.stopPropagation();
        onSelect(child.id);
      }}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        border: selectedChildId === child.id
          ? '2px solid #2563EB'
          : '1px dashed #E2E5EA',
        borderRadius: 6,
        minHeight: 60,
        background: '#fff',
        position: 'relative',
        cursor: 'grab'
      }}
    >
      <CanvasRenderer comp={child} />

      <div style={{
        position: 'absolute',
        top: -14,
        left: 4,
        fontSize: 9,
        background: '#2563EB',
        color: '#fff',
        padding: '1px 5px',
        borderRadius: 3
      }}>
        {child.type}
      </div>
    </div>
  );
}

export default function GridContainer({ comp, onChildSelect, selectedChildId, onReorder }) {
  const children = comp.children || [];
  const cols = comp.gridCols || 3;

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = children.findIndex(c => c.id === active.id);
    const newIndex = children.findIndex(c => c.id === over.id);

    const newChildren = arrayMove(children, oldIndex, newIndex);

    onReorder && onReorder(newChildren);
  };

  return (
    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={children.map(c => c.id)} strategy={rectSortingStrategy}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
          gap: comp.gap || 12,
          padding: 12,
          border: '1px dashed #CBD5E1',
          borderRadius: 8,
        }}>
          {children.length === 0 && (
            Array.from({ length: cols }).map((_, i) => (
              <div key={i} style={{
                height: 80,
                border: '1px dashed #E2E5EA',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#9CA3AF'
              }}>
                Drop here
              </div>
            ))
          )}

          {children.map(child => (
            <SortableItem
              key={child.id}
              child={child}
              selectedChildId={selectedChildId}
              onSelect={onChildSelect}
            />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
}